export const loanCalculatorData = [
  {
    id: 1,
    heading: "Home Loan EMI Calculator: Simplify Your Loan Planning",
    subHeading:
      "Understanding and planning your home loan EMI is critical to managing your finances efficiently. With Minemi’s EMI calculator, you can simulate your monthly payments, compare different loan scenarios, and make informed decisions. Whether you’re taking a new home loan or transferring an existing one, this page is your guide to effective EMI management.",

    notice:
      "With Minemi’s EMI calculator, you can confidently plan your finances, compare lenders, and make informed decisions. Start calculating today and take the first step towards owning your dream home!",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
